import {
  BrandingColorsToolResult,
  AutoFillFormTypeEnum,
} from 'libs/gb-dashboard/shared/data-access-ai/src/lib/+state/ai.models'
import { ToolHandler, ToolApplyContext } from '../tool-handler.interface'
import { ToolConfig, SetupGuideAiMessage, BrandingColorPreviewEntry } from '../../types/ai-chat.types'

export class BrandingColorsHandler implements ToolHandler {
  name = 'generate_branding_colors'
  config: ToolConfig = {
    labelKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BRANDING_COLORS.LABEL',
    generatingKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BRANDING_COLORS.GENERATING',
    resultKey: 'SETUP_GUIDE.AI_CHAT.TOOL.GENERATE_BRANDING_COLORS.RESULT',
    displayType: 'colors',
    dashboardPage: 'branding',
  }

  private readonly colorKeys: (keyof BrandingColorsToolResult)[] = [
    'primary_color',
    'accent_color',
    'background_color',
    'warn_color',
    'success_color',
    'banner_background_color',
  ]

  getPreviewData(message: SetupGuideAiMessage): BrandingColorPreviewEntry[] {
    if (!message.toolContent) {
      return []
    }

    const brandingColors = message.toolContent as BrandingColorsToolResult
    return this.colorKeys.map((key) => ({
      key,
      label: this.getReadableToolName(key),
      value: brandingColors[key],
    }))
  }

  canApply(message: SetupGuideAiMessage): boolean {
    return !!message.toolContent
  }

  apply(message: SetupGuideAiMessage, context: ToolApplyContext): void {
    if (!message.toolContent) {
      return
    }

    const brandingColors = message.toolContent as BrandingColorsToolResult
    const patchPayload = {
      primary_color: brandingColors.primary_color,
      accent_color: brandingColors.accent_color,
      background_color: brandingColors.background_color,
      warn_color: brandingColors.warn_color,
      success_color: brandingColors.success_color,
      banner_background_color: brandingColors.banner_background_color,
    }

    context.gbSetupGuideProgressService.setAiFormData(AutoFillFormTypeEnum.BrandingSettings, patchPayload)
  }

  private getReadableToolName(value: string): string {
    return value
      .split('_')
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join(' ')
  }
}
